export const environment = {
  name: "stage",
  production: false,
  adminServiceUrl: "https://api-stg.mailboxclubindonesia.org",
  glitchtipDsn: "https://4add147237794e32bbda9c7809910fea@errors-stg.mailboxclubindonesia.org/2",
};
